/** Invite acceptance page — user lands here from email link. */

import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/api/client";
import { useAuthStore } from "@/stores/auth";
import { Button } from "@/components/ui/Button";

export function InviteAcceptPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const loading = useAuthStore((s) => s.loading);
  const [status, setStatus] = useState<"loading" | "accepting" | "done" | "error">("loading");
  const [competitionId, setProjectId] = useState<string | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (loading) return;
    if (!user) {
      // Not logged in — redirect to login, then back here
      navigate(`/login`, { state: { from: { pathname: `/invite/${token}` } } });
      return;
    }
    setStatus("accepting");
    acceptInvitation();
  }, [user, loading, token, navigate]);

  const acceptInvitation = async () => {
    try {
      // The accept endpoint is not nested under a specific competition
      const result = await api.post<{ status: string; competition_id: string }>(
        `/api/competitions/00000000-0000-0000-0000-000000000000/invitations/accept/${token}`,
      );
      setProjectId(result.competition_id);
      setStatus("done");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to accept invitation");
      setStatus("error");
    }
  };

  if (status === "loading" || status === "accepting") {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="login-page">
        <div className="login-box">
          <div className="login-brand">RALEY</div>
          <p style={{ textAlign: "center", color: "var(--c-danger)", margin: "16px 0" }}>
            {error}
          </p>
          <Button variant="secondary" className="w-full" onClick={() => navigate("/dashboard")}>
            Go to Dashboard
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-brand">RALEY</div>
        <p style={{ textAlign: "center", color: "var(--c-success)", margin: "16px 0" }}>
          Invitation accepted!
        </p>
        <Button className="w-full" onClick={() => navigate(competitionId ? `/competition/${competitionId}` : "/dashboard")}>
          Go to Competition
        </Button>
      </div>
    </div>
  );
}
